<template>
  <b-list-group>
    <div ref="forumItemTopic" class="grid-container pr-3">
      <div ref="grid-item__topic" class="font-weight-bold grid-item__topic">Learning Topic</div>
      <div ref="grid-item__repiles" class="grid-item">Repiles</div>
      <div ref="grid-item__views" class="grid-item">Views</div>
    </div>
    <router-link
      v-for="(forum, index) in forums"
      :key="index"
      :to="{
        name: 'forum',
        params: { learningUnitId, forumId: forum.id },
        query: {
          previousPath: $route.fullPath
        }
      }"
    >
      <b-list-group-item
        ref="ListOfForumItem"
        class="grid-container list__forum-details row__topic"
      >
        <div class="grid-item__topic text__topic-title">
          {{ forum.topic }}
        </div>
        <div class="grid-item text__reply-number grid-item__detail">
          {{ forum.count_replies }}
        </div>
        <div class="grid-item text__view-number grid-item__detail">
          {{ forum.count_views }}
        </div>
      </b-list-group-item>
    </router-link>
  </b-list-group>
</template>

<script>
export default {
  props: {
    forums: {
      type: Array,
      default: () => []
    },
    learningUnitId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.grid-container {
  display: grid;
  grid-template-columns: 7fr 2fr 2fr;
  margin: 10px;
  gap: 16px;
}

.grid-item__topic {
  font-weight: 700;
  color: #3b3e66;
}

.grid-item {
  text-align: center;
}

.list__forum-details {
  border: 1px solid rgba(122, 123, 151, 0.3);
  box-shadow: 0px 4px 8.8px rgba(166, 166, 185, 0.55);
  border-radius: 10.4px;
  padding: 20px;
}

.grid-item__detail {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: rgba(7, 9, 25, 0.5);
}
</style>
